import { render, staticRenderFns } from "./DQShippingmark.vue?vue&type=template&id=6ff82e46&scoped=true&"
import script from "./DQShippingmark.vue?vue&type=script&lang=js&"
export * from "./DQShippingmark.vue?vue&type=script&lang=js&"
import style0 from "./DQShippingmark.vue?vue&type=style&index=0&id=6ff82e46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff82e46",
  null
  
)

export default component.exports